import { render, staticRenderFns } from "./nineLucky.vue?vue&type=template&id=02005c5c&scoped=true"
import script from "./nineLucky.vue?vue&type=script&lang=js"
export * from "./nineLucky.vue?vue&type=script&lang=js"
import style0 from "./nineLucky.vue?vue&type=style&index=0&id=02005c5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02005c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02005c5c')) {
      api.createRecord('02005c5c', component.options)
    } else {
      api.reload('02005c5c', component.options)
    }
    module.hot.accept("./nineLucky.vue?vue&type=template&id=02005c5c&scoped=true", function () {
      api.rerender('02005c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/lottery/components/nineLucky.vue"
export default component.exports